export const UsernameRegex = /^[a-zA-Z0-9]+$/;
export const EmailRegex = /^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/;
export const DigitRegex = /^\d+$/;
export const FullNameRegex = /^[a-zA-Z\s\.]+$/i;
